import { render } from "./workModal.vue?vue&type=template&id=da454c88"
import script from "./workModal.vue?vue&type=script&lang=js"
export * from "./workModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__